import RoadSpinner from "../../components/loads/RoadSpinner";
import TablaEventos from "../../components/eventos/tabla-eventos";
import FiltroEventos from "../../components/eventos/filtro-eventos";

const Eventos = ({
  filter,
  setFilter,
  fetch,
  data,
  loading,
  setData,
  setSalas,
  onClick,
  onChange,
  provincias,
  categorias,
  salas,
  navigate,
  user,
  setLoading,
  anterior,
  setAnterior,
}) => {
  return (
    <div className="min-vh-100" style={{ background: "#fff" }}>
      <div className="px-3">
        <div className="row">

          <div className="col-md-12">
            <FiltroEventos
              filter={filter}
              setFilter={setFilter}
              fetch={fetch}
              onClick={onClick}
              onChange={onChange}
              provincias={provincias}
              categorias={categorias}
              setData={setData}
              salas={salas}
              setSalas={setSalas}
              loading={loading}
              setLoading={setLoading}
              user={user}
              setAnterior={setAnterior}
              anterior={anterior}
            />
          </div>

          <div className="col-md-12">
            {loading ? (
              <div className="w-100 justify-content-center py-5">
                <RoadSpinner />
              </div>
            ) : (
              <TablaEventos
                data={data}
                setData={setData}
                onClick={onClick}
                navigate={navigate}
                user={user}
                filter={filter}
                setFilter={setFilter}
                setLoading={setLoading}
              />
            )}
          </div>

          <div className="col-md-12 d-none">
            <div className="my-3">
              {data.links.map((link) => {
                if (link.label == "&laquo; Previous") {
                  return (
                    <label
                      className={`btn btn-outline-dark me-1 ${
                        link.active ? "active" : ""
                      } ${link.url ? "" : "disabled"}`}
                      onClick={() => {
                        let params = {
                          ...filter,
                          page: data.current_page - 1,
                        };

                        setLoading(true);
                        setFilter({
                          ...params,
                        });

                        fetch(setData, params, "/eventos", null, setLoading);
                      }}
                    >
                      <i class="bi bi-chevron-left"></i>
                      ANTERIOR
                    </label>
                  );
                }
                if (link.label == "Next &raquo;") {
                  return (
                    <label
                      className={`btn btn-outline-dark ${
                        link.active ? "active" : ""
                      } ${link.url ? "" : "disabled"}`}
                      onClick={() => {
                        let params = {
                          ...filter,
                          page: data.current_page + 1,
                        };

                        setLoading(true);
                        setFilter({
                          ...params,
                        });

                        fetch(setData, params, "/eventos", null, setLoading);
                      }}
                    >
                      SIGUIENTE
                      <i class="bi bi-chevron-right"></i>
                    </label>
                  );
                }
                return (
                  <label
                    className={`btn btn-outline-dark me-1 ${
                      link.active ? "active" : ""
                    }`}
                    onClick={() => {
                      let params = {
                        ...filter,
                        page: link.label,
                      };

                      setLoading(true);
                      setFilter({
                        ...params,
                      });

                      fetch(setData, params, "/eventos", null, setLoading);
                    }}
                  >
                    {link.label}
                  </label>
                );
              })}
              <label className={`btn btn-dark ms-1`}>
                EVENTOS {data?.total}
              </label>
            </div>

            <div className="my-3">
              {data.links.map((link) => {
                if (link.label == "&laquo; Previous") {
                  return (
                    <label
                      className={`btn btn-outline-dark me-1 ${
                        link.active ? "active" : ""
                      } ${link.url ? "" : "disabled"}`}
                      onClick={() => {
                        let params = {
                          ...filter,
                          page: data.current_page - 1,
                        };

                        setLoading(true);
                        setFilter({
                          ...params,
                        });

                        fetch(setData, params, "/eventos", null, setLoading);
                      }}
                    >
                      <i class="bi bi-chevron-left"></i>
                      ANTERIOR
                    </label>
                  );
                }
                if (link.label == "Next &raquo;") {
                  return (
                    <label
                      className={`btn btn-outline-dark ${
                        link.active ? "active" : ""
                      } ${link.url ? "" : "disabled"}`}
                      onClick={() => {
                        let params = {
                          ...filter,
                          page: data.current_page + 1,
                        };

                        setLoading(true);
                        setFilter({
                          ...params,
                        });

                        fetch(setData, params, "/eventos", null, setLoading);
                      }}
                    >
                      SIGUIENTE
                      <i class="bi bi-chevron-right"></i>
                    </label>
                  );
                }
                return (
                  <label
                    className={`btn btn-outline-dark me-1 ${
                      link.active ? "active" : ""
                    }`}
                    onClick={() => {
                      let params = {
                        ...filter,
                        page: link.label,
                      };

                      setLoading(true);
                      setFilter({
                        ...params,
                      });

                      fetch(setData, params, "/eventos", null, setLoading);
                    }}
                  >
                    {link.label}
                  </label>
                );
              })}
              <label className={`btn btn-dark ms-1`}>
                EVENTOS {data?.total}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Eventos;
